import { backendApi } from "@/services/backend/api";
import { Result } from "@/services/backend/search/types/search";

const searchApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    search: build.query<Result, SearchQuery>({
      query: (query) => ({
        url: "search/search",
        params: query,
        cache: "no-cache",
      }),
    }),
  }),
});

export const { useSearchQuery } = searchApi;

interface SearchQuery {
  query: string;
  // Optional cap on results per group. Omitted by the header dropdown
  // (backend default), set by the full search-results page.
  limit?: number;
}
